import { SortingMode } from './sorting-mode';

export default class Sorting {
    Member: string = "";
    Mode: SortingMode = SortingMode.DESC;
}